import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
  select,
} from '@ngrx/store';
import { pipe } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { UserProfile } from 'src/app/models/user-profile/user-profile';
import { AllActionsUnion } from '../../../app.actions';
import { LoadingState } from '../restaurant/restaurant.reducer';
import {
  clearUserProfile,
  storeErrorMessage,
  storeSuccessMessage,
  storeUserProfile,
  updateLoadingState,
} from './user-profile.actions';

export interface UserProfileState {
  userProfile: UserProfile;
  loadingState: LoadingState;
  errorMessage: string;
  successMessage: string;
}

const initialState: UserProfileState = {
  userProfile: new UserProfile(),
  loadingState: 'none',
  errorMessage: '',
  successMessage: '',
};

export const featureName = 'userProfileFeature';

export function userProfileReducer(
  state_: UserProfileState | undefined,
  action: AllActionsUnion,
): UserProfileState {
  const reducer_ = createReducer<UserProfileState>(
    initialState,
    on(
      storeUserProfile,
      (state, { payload }): UserProfileState => {
        return { ...state, userProfile: payload };
      },
    ),
    on(
      clearUserProfile,
      (state): UserProfileState => {
        return { ...initialState };
      },
    ),
    on(
      updateLoadingState,
      (state, { payload }): UserProfileState => {
        return { ...state, loadingState: payload };
      },
    ),
    on(
      storeErrorMessage,
      (state, { payload }): UserProfileState => {
        return { ...state, errorMessage: payload };
      },
    ),
    on(
      storeSuccessMessage,
      (state, { payload }): UserProfileState => {
        return { ...state, successMessage: payload };
      },
    ),
  );
  return reducer_(state_, action);
}

const getFeature = createFeatureSelector<UserProfileState>(featureName);

export const getUserProfile = pipe(
  select(
    createSelector(
      getFeature,
      v => v.userProfile,
    ),
  ),
  distinctUntilChanged(),
);

export const getLoadingState = pipe(
  select(
    createSelector(
      getFeature,
      v => v.loadingState,
    ),
  ),
  distinctUntilChanged(),
);

export const getErrorMessage = pipe(
  select(
    createSelector(
      getFeature,
      v => v.errorMessage,
    ),
  ),
  filter(v => v !== ''),
  distinctUntilChanged(),
);

export const getSuccessMessage = pipe(
  select(
    createSelector(
      getFeature,
      v => v.successMessage,
    ),
  ),
  distinctUntilChanged(),
);
